import { useLocation, useNavigate, useParams } from "react-router-dom";
import { appendSearchToPath } from "src/customHooks/usePaginatedTableSearchParams";
import SlotRequestDetails from "../../components/slot-request-details";
import { useGetSlotRequestByIdQuery } from "../../slot-requests.service";

const SlotRequestDetailsPage = () => {
  const { id } = useParams<{ id: string }>();
  const location = useLocation();
  const navigate = useNavigate();
  const backToRequests = appendSearchToPath("/slot-requests", location.search);
  const { data: request, isLoading, isError } = useGetSlotRequestByIdQuery(id || "");

  if (isLoading) return <div className="p-6">Loading...</div>;
  if (isError || !request) {
    return (
      <div className="page_container">
        <div className="border border-red-200 bg-red-50 p-6 text-center">
          <h2 className="mb-2 text-xl font-semibold text-red-800">Slot request not found</h2>
          <p className="mb-5 text-sm text-red-700">The request may have been removed or the ID is invalid.</p>
          <button onClick={() => navigate(backToRequests)} className="bg-red-600 px-4 py-2 text-sm font-medium text-white hover:bg-red-700">
            Back to requests
          </button>
        </div>
      </div>
    );
  }

  return <SlotRequestDetails request={request} onBack={() => navigate(backToRequests)} />;
};

export default SlotRequestDetailsPage;
